/** Every user-facing string of metric suggestions (spec §3.9, §7). */
export const SUGGESTION_COPY = {
  track: 'Track',
  retry: 'Try again',
  notNow: 'Not now',
  notForUs: 'Not for us',
  settingUp: 'Setting this up…',
  applyStuck: 'Setting this up is taking longer than expected.',
  tracked: 'Tracking now.',
  applyFailed: 'Graphit could not set this up. Try again.',
  evidenceLabel: 'Why Graphit suggests this',
  pageTitle: 'Metric suggestions',
  pageDescription: 'Metrics worth tracking, chosen from what your church database shows you actually do.',
  find: 'Find suggestions',
  finding: 'Looking…',
  moreIdeas: 'More ideas',
  empty: 'No suggestions right now.',
  noConnectionTitle: 'No church management system connected',
  noConnection: 'Connect your church management system in Integrations to get suggestions.',
  notAvailable: 'Suggestions aren’t turned on for this workspace.',
  adminsOnly: 'Only owners and administrators can review suggestions.',
  loadFailed: 'Couldn’t load suggestions.',
  decideFailed: 'Couldn’t save that. Try again.',
  stepIntro: 'Graphit looked at what your church does most weeks. Track any of these, or skip this step.',
  focusQuestion: 'What matters most right now? (optional)',
  update: 'Update suggestions',
  focusSaveFailed: 'Couldn’t save what matters most. Try again.',
  focusLoadFailed: 'Couldn’t load what matters most to your church.',
  cardTitle: 'Suggested metrics',
  viewAll: 'See all suggestions',
  stillWorking: 'Still working. A large church database can take a couple of minutes.',
  runFailed: 'The suggestions could not be built. Try again.',
  runTimedOut: 'Finding suggestions is taking too long. Try again in a few minutes.',
  setupCheckFailed: 'Graphit is setting this up. Refresh the page to see when it is ready.',
}

/** The run's `reason` when it has nothing to show. */
export const REASON_COPY = {
  profile_unavailable: 'We’re still learning about your church; check back tomorrow.',
  not_supported: 'This connection can’t suggest metrics yet.',
  connection_not_ready: 'Reconnect this connection to get suggestions.',
  nothing_to_suggest: 'No suggestions right now.',
}

export const FOCUS_AREA_LABELS = {
  weekend: 'Weekend services',
  next_gen: 'Kids & students',
  groups: 'Groups',
  serving: 'Serving',
  guests: 'Guests',
  discipleship_steps: 'Next steps',
  giving: 'Giving',
  online: 'Online',
}
